import { render } from "./query_express_info.vue?vue&type=template&id=d950ebe8&scoped=true"
import script from "./query_express_info.vue?vue&type=script&lang=js"
export * from "./query_express_info.vue?vue&type=script&lang=js"

import "./query_express_info.vue?vue&type=style&index=0&id=d950ebe8&scoped=true&lang=css"

import exportComponent from "E:\\daxiang\\code\\dx_project_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d950ebe8"]])

export default __exports__